module.exports = __webpack_public_path__ + "img/order_takeaway.9c3ff8c1.png";